// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PortCall\ApiPortCallVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { PortCallVersion as _PortCallVersion, PortCallVersionData as _PortCallVersionData, PortCallVersionOptions as _PortCallVersionOptions } from 'data/models/PortCallVersion';
import { RecurringBatchSelf, RecurringBatchSelfData, RecurringBatchSelfOptions } from 'data/models/RecurringBatchSelf';

// PortCallVersionData is the class that PortCallVersion serializes to/from
export interface PortCallVersionData {
    ChangeId : number;
    Id : number;
	
    AgentId : number;
    Batch : RecurringBatchSelfData | null;
    BatchId : number | null;
    Change : ChangeData | null;
    EventsAbout : EventData[] | null;
    EventsReferencing : EventData[] | null;
    NextVersion : _PortCallVersionData[] | null;
    PortId : number;
    PrevChange : ChangeData | null;
    PrevChangeId : number | null;
    PrevVersion : _PortCallVersionData | null;
    RequestorId : number;
    Self : PortCallSelfData | null;
    SharingId : number;
    VesselId : number | null;
	
    AirDraft : NullableMeasurementData;
    DeepDraft : NullableMeasurementData;
    Deleted : boolean;
    ExtraDataJSON : string | null;
    Guid : /* GUID */ string;
    LastPortOfCall : string | null;
    LengthOnlyLength : NullableMeasurementData;
    NextPortOfCall : string | null;
    Unlisted : boolean;
    UnlistedOverride : boolean | null;
    VoyageNumber : string | null;
}

// PortCallVersionOptions is the class which may be passed to the PortCallVersion constructor to define optional initial data values
export interface PortCallVersionOptions {
    ChangeId : number;
    Id : number;
	
    AgentId? : number;
    Batch? : RecurringBatchSelfOptions | null;
    BatchId? : number | null;
    Change? : ChangeOptions | null;
    EventsAbout? : EventOptions[] | null;
    EventsReferencing? : EventOptions[] | null;
    NextVersion? : _PortCallVersionOptions[] | null;
    PortId? : number;
    PrevChange? : ChangeOptions | null;
    PrevChangeId? : number | null;
    PrevVersion? : _PortCallVersionOptions | null;
    RequestorId? : number;
    Self? : PortCallSelfOptions | null;
    SharingId? : number;
    VesselId? : number | null;
	
    AirDraft? : NullableMeasurementOptions;
    DeepDraft? : NullableMeasurementOptions;
    Deleted? : boolean;
    ExtraDataJSON? : string | null;
    Guid? : /* GUID */ string;
    LastPortOfCall? : string | null;
    LengthOnlyLength? : NullableMeasurementOptions;
    NextPortOfCall? : string | null;
    Unlisted? : boolean;
    UnlistedOverride? : boolean | null;
    VoyageNumber? : string | null;
}

export class PortCallVersion {
    public ChangeId : DataSignal<number>;
    public Id : DataSignal<number>;
	
    public AgentId : DataSignal<number>;
    public Batch : DataSignal<RecurringBatchSelf | null>;
    public BatchId : DataSignal<number | null>;
    public Change : DataSignal<Change | null>;
    public EventsAbout : SDataArray<Event>;
    public EventsReferencing : SDataArray<Event>;
    public NextVersion : SDataArray<_PortCallVersion>;
    public PortId : DataSignal<number>;
    public PrevChange : DataSignal<Change | null>;
    public PrevChangeId : DataSignal<number | null>;
    public PrevVersion : DataSignal<_PortCallVersion | null>;
    public RequestorId : DataSignal<number>;
    public Self : DataSignal<PortCallSelf | null>;
    public SharingId : DataSignal<number>;
    public VesselId : DataSignal<number | null>;
	
    public AirDraft : NullableMeasurement;
    public DeepDraft : NullableMeasurement;
    public Deleted : DataSignal<boolean>;
    public ExtraDataJSON : DataSignal<string | null>;
    public Guid : DataSignal<string>;
    public LastPortOfCall : DataSignal<string | null>;
    public LengthOnlyLength : NullableMeasurement;
    public NextPortOfCall : DataSignal<string | null>;
    public Unlisted : DataSignal<boolean>;
    public UnlistedOverride : DataSignal<boolean | null>;
    public VoyageNumber : DataSignal<string | null>;

    constructor();
    constructor(data : PortCallVersionOptions);
    constructor(data: PortCallVersionOptions | null = null) {
        this.ChangeId = jsonableObservable(S.value<number>(data && data.ChangeId !== undefined ? data.ChangeId : 0));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.AgentId = jsonableObservable(S.value<number>(data && data.AgentId !== undefined ? data.AgentId : 0));
        this.Batch = S.value<RecurringBatchSelf | null>(null);
        this.BatchId = jsonableObservable(S.value<number | null>(data && data.BatchId !== undefined ? data.BatchId : null));
        this.Change = S.value<Change | null>(null);
        this.EventsAbout = SArray<Event>([]);
        this.EventsReferencing = SArray<Event>([]);
        this.NextVersion = SArray<_PortCallVersion>([]);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
        this.PrevChange = S.value<Change | null>(null);
        this.PrevChangeId = jsonableObservable(S.value<number | null>(data && data.PrevChangeId !== undefined ? data.PrevChangeId : null));
        this.PrevVersion = S.value<_PortCallVersion | null>(null);
        this.RequestorId = jsonableObservable(S.value<number>(data && data.RequestorId !== undefined ? data.RequestorId : 0));
        this.Self = S.value<PortCallSelf | null>(null);
        this.SharingId = jsonableObservable(S.value<number>(data && data.SharingId !== undefined ? data.SharingId : 0));
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.AirDraft = data && data.AirDraft !== undefined ? new NullableMeasurement(data.AirDraft) : new NullableMeasurement();
        this.DeepDraft = data && data.DeepDraft !== undefined ? new NullableMeasurement(data.DeepDraft) : new NullableMeasurement();
        this.Deleted = jsonableObservable(S.value<boolean>(data && data.Deleted !== undefined ? data.Deleted : false));
        this.ExtraDataJSON = jsonableObservable(S.value<string | null>(data && data.ExtraDataJSON !== undefined ? data.ExtraDataJSON : null));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.LastPortOfCall = jsonableObservable(S.value<string | null>(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.LengthOnlyLength = data && data.LengthOnlyLength !== undefined ? new NullableMeasurement(data.LengthOnlyLength) : new NullableMeasurement();
        this.NextPortOfCall = jsonableObservable(S.value<string | null>(data && data.NextPortOfCall !== undefined ? data.NextPortOfCall : null));
        this.Unlisted = jsonableObservable(S.value<boolean>(data && data.Unlisted !== undefined ? data.Unlisted : false));
        this.UnlistedOverride = jsonableObservable(S.value<boolean | null>(data && data.UnlistedOverride !== undefined ? data.UnlistedOverride : null));
        this.VoyageNumber = jsonableObservable(S.value<string | null>(data && data.VoyageNumber !== undefined ? data.VoyageNumber : null));
    }

    static key(obj : PortCallVersion) {
        return obj.ChangeId() + '\u2618' + obj.Id();
    }
    
    static dataKey(obj : PortCallVersionOptions) {
        return obj.ChangeId + '\u2618' + obj.Id;
    }

    static update(obj : PortCallVersion, data : PortCallVersionOptions) {
        S.freeze(() => {
            if (data.ChangeId !== undefined) obj.ChangeId(data.ChangeId);
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AgentId !== undefined) obj.AgentId(data.AgentId);
            if (data.BatchId !== undefined) obj.BatchId(data.BatchId);
            if (data.PortId !== undefined) obj.PortId(data.PortId);
            if (data.PrevChangeId !== undefined) obj.PrevChangeId(data.PrevChangeId);
            if (data.RequestorId !== undefined) obj.RequestorId(data.RequestorId);
            if (data.SharingId !== undefined) obj.SharingId(data.SharingId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.AirDraft !== undefined) NullableMeasurement.update(obj.AirDraft, data.AirDraft);
            if (data.DeepDraft !== undefined) NullableMeasurement.update(obj.DeepDraft, data.DeepDraft);
            if (data.Deleted !== undefined) obj.Deleted(data.Deleted);
            if (data.ExtraDataJSON !== undefined) obj.ExtraDataJSON(data.ExtraDataJSON);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.LastPortOfCall !== undefined) obj.LastPortOfCall(data.LastPortOfCall);
            if (data.LengthOnlyLength !== undefined) NullableMeasurement.update(obj.LengthOnlyLength, data.LengthOnlyLength);
            if (data.NextPortOfCall !== undefined) obj.NextPortOfCall(data.NextPortOfCall);
            if (data.Unlisted !== undefined) obj.Unlisted(data.Unlisted);
            if (data.UnlistedOverride !== undefined) obj.UnlistedOverride(data.UnlistedOverride);
            if (data.VoyageNumber !== undefined) obj.VoyageNumber(data.VoyageNumber);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallVersion.ts